<template>
  <div>
      <!-- 云校 -->
      <yx-comment-preview v-if="productCode == 1" />
      <!-- 成长粒 -->
      <czl-comment-preview v-if="productCode == 16" />
  </div>
</template>

<script>
  import yxCommentPreview from './components/yx-comment-preview.vue';
  import czlCommentPreview from './components/czl-comment-preview.vue';

  export default {
    data() {
      return {
        pageTitle: "点评详情",
        productCode: '1'
      }
    },
    components: {
      yxCommentPreview,
      czlCommentPreview
    },
    created() {
      this.productCode = this.$route.query.productCode || '1';
    }
  }
</script>